import type { Area } from 'react-easy-crop'

function loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })
}

export async function cropImageToDataUrl(sourceUrl: string, area: Area, outputSize = 256): Promise<string> {
    const image = await loadImage(sourceUrl)

    const canvas = document.createElement('canvas')
    canvas.width = outputSize
    canvas.height = outputSize
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Canvas context unavailable')

    ctx.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, outputSize, outputSize)

    return canvas.toDataURL('image/jpeg', 0.9)
}
